import { defaultServer } from '~/api/def/servers/defaultServer';
import { getExecEndpoint } from '~/api/service/getExecEndpoint';
import { CrudBqResponse } from './types';

export const sectorEndpoint = {
  server: defaultServer,
  path: 'crud/sector',
  description: 'Sector operations',
};

const endpointSectorExec = getExecEndpoint<SectorEndpointDef>(sectorEndpoint);

export const endpointSectorGET = async () => {
  const response = await endpointSectorExec<'GET'>({
    method: 'GET',
  });

  if (!response) {
    throw new Error('Could not get sectors');
  }

  if (response.success === 0) {
    throw new Error('Could not get sectors');
  }

  return response.data;
};

export interface SectorEndpointDef {
  endpoint: typeof sectorEndpoint;
  methods: {
    GET: {
      response: SectorGetDataResponse;
    };
    POST: {
      response: SectorPostResponse;
      payload: Omit<SectorPostPayload, 'id'>;
    };
    PATCH: {
      response: SectorPostResponse;
      payload: SectorPostPayload;
    };
  };
}

export type SectorPostResponse = CrudBqResponse<{ id: string }>;

export type SectorGetDataResponse = CrudBqResponse<SectorGetData[]>;

export type SectorPostPayload = Omit<
  SectorGetData,
  'id' | 'createdAt' | 'updatedAt'
>;

export type SectorGetData = {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string | null;
};
